import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { getPatient } from '~/store/reducers/patients'
import { getClientId, getPatientId } from '~/store/reducers/soap'

import { useRightRailOverlay } from '../../context/RightRailOverlayContext'
import LabsHistoryWidget from '../../summary/labs/LabsHistoryWidget'
import PatientDetailsHeader from '../../summary/patient-details/PatientDetailsHeader'
import PrescriptionsSummaryWidget from '../../summary/prescriptions/PrescriptionsSummaryWidget'
import ProblemsSummaryWidget from '../../summary/problems/ProblemsSummaryWidget'
import RhapVitalsWidget from '../../summary/vitals/RhapVitalsWidget'

import styles from './SoapPatientMedicalRecordRightRail.module.scss'

export const SoapPatientMedicalRecordRightRail = () => {
  const clientId = useSelector(getClientId) ?? ''
  const patientId = useSelector(getPatientId) ?? ''
  const patient = useSelector(getPatient(patientId))
  const { isOverlayOpen, overlayContent } = useRightRailOverlay()

  return (
    <div className={styles.rightRailContainer}>
      <div className={styles.patientDetailsHeader}>
        <PatientDetailsHeader
          showSoapHeaderMenu
          clientId={clientId}
          patient={patient}
        />
      </div>
      <div
        className={classNames(styles.railContent, {
          [styles.overlayOpen]: isOverlayOpen,
        })}
      >
        {isOverlayOpen && (
          <div className={styles.overlayContainer}>{overlayContent}</div>
        )}
        <>
          <RhapVitalsWidget patientId={patientId} />
          <ProblemsSummaryWidget clientId={clientId} patientId={patientId} />
          <PrescriptionsSummaryWidget
            clientId={clientId}
            patientId={patientId}
          />
          <LabsHistoryWidget clientId={clientId} patientId={patientId} />
        </>
      </div>
    </div>
  )
}
